export interface ITranslations {
  term: string;
  translation: string;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const useTranslation = (translations: any, term: string) => {
  const existingTagInfos =
    translations &&
    translations?.filter(
      (termsObj: { term: string }) => termsObj.term === term,
    );

  if (
    existingTagInfos &&
    existingTagInfos !== null &&
    existingTagInfos.length > 0 &&
    existingTagInfos[0].translation !== null &&
    existingTagInfos[0].translation !== undefined &&
    existingTagInfos[0].translation !== ''
  ) {
    return existingTagInfos[0].translation;
  }

  return term;
};

const takeTranslations = (translations: [ITranslations], term: string) => {
  const existingTagInfos =
    translations &&
    translations?.filter(
      (termsObj: { term: string }) => termsObj.term === term,
    );

  if (
    existingTagInfos &&
    existingTagInfos !== null &&
    existingTagInfos.length > 0 &&
    existingTagInfos[0].translation !== null &&
    existingTagInfos[0].translation !== undefined &&
    existingTagInfos[0].translation !== ''
  ) {
    return existingTagInfos[0].translation;
  }

  return term;
};

const useTranslationWithoutStore = (
  translations: [ITranslations],
  term: string,
) => {
  return takeTranslations(translations, term);
};

export { useTranslationWithoutStore as t2 };
